import { useAppSelector } from "@/hooks/hook";
import { formStateChange } from "@/redux/slices/formSlice";
import { logout } from "@/redux/slices/userSlice";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import logo from "../assets/images/navlogo.png"; // Import your logo image
import ChangesAlert from "@/components/alert/ChangesAlert";
import { LogoutModalComp } from "@/components/modals/LogoutModalComp";
import { Link } from "react-router-dom";
import { currentBusinessSave } from "@/redux/slices/businessSlice";

const authRoutes = [
    "/checkemail",
    "/signup",
    "/login",
    "/forget/password",
    "/reset-password",
    "/checkemail",
];

interface User {
    first_name: string;
    last_name: string;
    roles: string;
    // Add other properties of the user object if available
}

export const SideBar = () => {
    const user = useAppSelector((store) => store.user);

    const { isChanged } = useAppSelector((store) => store.form);
    const [modal, setModal] = useState<boolean>(false);
    const [logoutModal, setLogoutModal] = useState<boolean>(false);
    const [navigateTo, setNavigtateTo] = useState<string>("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const [openDropdown, setOpenDropdown] = useState<boolean>(false);
    // const dropdownRef = useRef<HTMLDivElement>(null);
    const location = useLocation();
    // const [openSideBar, setOpenSideBar] = useState<boolean>(false);
    const path = location.pathname;
    const searchPath = location.search;

    // const closeSidebar = () => setOpenSideBar(false);
    // const openSidebar = () => setOpenSideBar(true);
    if (authRoutes.includes(path)) {
        return null;
    }

    const logoutUser = () => {
        dispatch(currentBusinessSave(null));
        dispatch(logout());
        navigate("/login");
        setLogoutModal(false);
        // setModal(true)
    };

    const handleModalOkay = () => {
        setModal(false);
        setLogoutModal(false);
    };

    const handleModalCancel = () => {
        dispatch(formStateChange(false));
        setModal(false);
        navigate(navigateTo);
    };

    const canelLogoutFun = () => {
        setLogoutModal(false);
    };

    const tryToNavigate = (path: string) => {
        console.log("event", path);
        if (isChanged) {
            console.log("true");
            setNavigtateTo(path);
            setModal(true);
        } else {
            console.log("else");

            navigate(path);
        }
    };
    if ((!user.card || !user.application_access) && user.roles !== "admin") {
        return (
            <div className="relative  hidden lg:block">
                <div className="h-screen flex flex-col p-4 px-8 sticky z-50 top-0 bottom-0 left-0 bg-white overflow-hidden">
                    <div
                        onClick={() => {
                            tryToNavigate("/");
                        }}
                        className="flex items-center cursor-pointer shrink-0"
                    >
                        <img src={logo} alt="Logo" className="w-36 mr-4" />
                    </div>
                    {/* Navigation links - scrollable when options overflow */}
                    <div className="flex flex-col flex-1 min-h-0 mt-8 tracking-wider">
                        <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
                            <div className="flex flex-col gap-1 mt-4 pl-5">
                                {user.futurePayment && (
                                    <Link
                                        id="navItem1"
                                        to="/events?tab=Bookings"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            tryToNavigate("/events?tab=Bookings");
                                        }}
                                        className={`cursor-pointer py-2 rounded-full w-fit ${path === "/events" && searchPath !== "?tab=Leads"
                                            ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                            : "text-start font-medium text-gray-600"
                                            }`}
                                    >
                                        Bookings
                                    </Link>
                                )}
                                {user.futurePayment && (
                                    <Link
                                        id="navItem1"
                                        to="/events?tab=Leads"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            tryToNavigate("/events?tab=Leads");
                                        }}
                                        className={`cursor-pointer py-2 rounded-full w-fit ${path === "/events" && searchPath === "?tab=Leads"
                                            ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                            : "text-start font-medium text-gray-600"
                                            }`}
                                    >
                                        Quotes
                                    </Link>
                                )}
                                <Link
                                    id="navItem1"
                                    to="/billing"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        tryToNavigate("/billing");
                                    }}
                                    className={`cursor-pointer py-2 rounded-full w-fit ${path === "/billing"
                                        ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                        : "text-start font-medium text-gray-600"
                                        }`}
                                >
                                    Billing
                                </Link>
                            </div>
                        </div>
                        <div className="shrink-0 pt-4">
                            <div className="flex flex-col gap-2">
                                <p
                                    onClick={() => setLogoutModal(true)}
                                    className="text-start font-medium text-gray-600 cursor-pointer"
                                >
                                    Logout
                                </p>
                            </div>
                        </div>
                    </div>
                    {modal && (
                        <ChangesAlert
                            isOpen={modal}
                            title="Unsaved Changed"
                            desc={path === "/quoteBuilder" ? "Are you sure you want to leave without saving this quote?" : "You have unsaved changes. Are you sure you want to leave?"}
                            positiveButtonText="No, Stay"
                            negativeButtonText="Yes, Leave"
                            handleDiscardChanges={handleModalCancel}
                            handleSaveChanges={handleModalOkay}
                        />
                    )}
                    {logoutModal && (
                        <LogoutModalComp
                            isOpen={logoutModal}
                            title="Logout"
                            desc="Are you sure you want to logout"
                            positiveButtonText="No, Stay"
                            negativeButtonText="Yes, Leave"
                            handleDiscardChanges={logoutUser}
                            handleSaveChanges={canelLogoutFun}
                        />
                    )}
                </div>
            </div>
        );
    }
    return (
        <div className="relative  hidden lg:block ">
            <div className="h-screen flex flex-col p-4 px-8 sticky z-50 top-0 bottom-0 left-0 bg-white overflow-hidden">
                <div
                    onClick={() => {
                        tryToNavigate("/");
                    }}
                    className="flex items-center cursor-pointer shrink-0"
                >
                    <img src={logo} alt="Logo" className="w-36" />
                </div>
                {/* Navigation links - scrollable when options overflow */}
                <div className="flex flex-col flex-1 min-h-0 mt-8 tracking-wider">
                    <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
                        <div className="flex flex-col gap-1 mt-4 pl-5">
                            {user?.roles == "admin" && (
                                <Link
                                    id="navItem1"
                                    to="/company"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        tryToNavigate("/company");
                                    }}
                                    className={`cursor-pointer py-2 rounded-full w-fit ${path === "/company"
                                        ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                        : "text-start font-medium text-gray-600"
                                        }`}
                                >
                                    Businesses
                                </Link>
                                // <button
                                //   id="navItem1"
                                //   onClick={() => {
                                //     tryToNavigate("/company");
                                //   }}
                                //   className={`cursor-pointer py-2 rounded-full w-fit    ${
                                //     path === "/company"
                                //       ? "text-white  cursor-pointer bg-primary-red  -ml-5  px-6"
                                //       : "text-start font-medium text-gray-600  "
                                //   }`}
                                // >
                                //   Businesses
                                // </button>
                            )}
                            {/* <button
              id="navItem1"
              onClick={() => {
                tryToNavigate("/dashboard");
              }}
              className={`cursor-pointer py-2 rounded-full w-fit    ${
                path === "/dashboard"
                  ? "text-white  cursor-pointer bg-primary-red  -ml-5  px-6"
                  : "text-start font-medium text-gray-600  "
              }`}
            >
              Home
            </button> */}
                            <Link
                                id="navItem1"
                                to="/dashboard"
                                onClick={(e) => {
                                    e.preventDefault();
                                    tryToNavigate("/dashboard");
                                }}
                                className={`cursor-pointer py-2 rounded-full w-fit ${path === "/dashboard"
                                    ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                    : "text-start font-medium text-gray-600"
                                    }`}
                            >
                                Home
                            </Link>
                            <Link
                                id="navItem1"
                                to="/events?tab=Bookings"
                                onClick={(e) => {
                                    e.preventDefault();
                                    tryToNavigate("/events?tab=Bookings");
                                }}
                                className={`cursor-pointer py-2 rounded-full w-fit ${path === "/events" && searchPath !== "?tab=Leads"
                                    ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                    : "text-start font-medium text-gray-600"
                                    }`}
                            >
                                Bookings
                            </Link>
                            <Link
                                id="navItem1"
                                to="/events?tab=Leads"
                                onClick={(e) => {
                                    e.preventDefault();
                                    tryToNavigate("/events?tab=Leads");
                                }}
                                className={`cursor-pointer py-2 rounded-full w-fit ${path === "/events" && searchPath === "?tab=Leads"
                                    ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                    : "text-start font-medium text-gray-600"
                                    }`}
                            >
                                Quotes
                            </Link>
                            {/* <button
              id="navItem1"
              onClick={() => {
                tryToNavigate("/events?tab=Upcoming");
              }}
              className={`cursor-pointer py-2 rounded-full w-fit   ${
                path === "/events"
                  ? "text-white  cursor-pointer bg-primary-red  -ml-5 px-6"
                  : "text-start font-medium text-gray-600  "
              }`}
            >
              Bookings
            </button> */}
                            <Link
                                id="navItem1"
                                to="/bartenders/schedule"
                                onClick={(e) => {
                                    e.preventDefault();
                                    tryToNavigate("/bartenders/schedule");
                                }}
                                className={`cursor-pointer py-2 rounded-full w-fit ${path === "/bartenders/schedule"
                                    ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                    : "text-start font-medium text-gray-600"
                                    }`}
                            >
                                Scheduler
                            </Link>
                            {/* <button
              id="navItem1"
              onClick={() => {
                tryToNavigate("/bartenders/schedule");
              }}
              className={`cursor-pointer py-2  rounded-full w-fit  ${
                path === "/bartenders/schedule"
                  ? "text-white  cursor-pointer bg-primary-red  -ml-5 px-6"
                  : " text-start font-medium text-gray-600 "
              }`}
            >
              Scheduler
            </button> */}
                            {/* <button
              id="navItem1"
              onClick={() => {
                tryToNavigate("/");
              }}
              className={`cursor-pointer py-2 rounded-full  w-fit ${
                path === "/"
                  ? "text-white  cursor-pointer bg-primary-red  -ml-5 px-6 "
                  : " text-start font-medium text-gray-600"
              }`}
            >
              Bartenders
            </button> */}
                            <Link
                                id="navItem1"
                                to="/"
                                onClick={(e) => {
                                    e.preventDefault();
                                    tryToNavigate("/");
                                }}
                                className={`cursor-pointer py-2 rounded-full w-fit ${path === "/"
                                    ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                    : "text-start font-medium text-gray-600"
                                    }`}
                            >
                                Bartenders
                            </Link>
                            {user?.roles == "admin" && (
                                // <button
                                //   id="navItem1"
                                //   onClick={() => {
                                //     tryToNavigate("/payments");
                                //   }}
                                //   className={`cursor-pointer py-2 rounded-full w-fit    ${
                                //     path === "/payments"
                                //       ? "text-white  cursor-pointer bg-primary-red  -ml-5  px-6"
                                //       : "text-start font-medium text-gray-600  "
                                //   }`}
                                // >
                                //   Payments
                                // </button>
                                <Link
                                    id="navItem1"
                                    to="/payments"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        tryToNavigate("/payments");
                                    }}
                                    className={`cursor-pointer py-2 rounded-full w-fit ${path === "/payments"
                                        ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                        : "text-start font-medium text-gray-600"
                                        }`}
                                >
                                    Payments
                                </Link>
                            )}
                            {/* <button
              id="navItem1"
              onClick={() => {
                tryToNavigate("/pricecalculator");
              }}
              className={`cursor-pointer py-2 rounded-full w-fit  ${
                path === "/pricecalculator"
                  ? "text-white  cursor-pointer bg-primary-red  -ml-5 px-6"
                  : "text-start font-medium text-gray-600 "
              }`}
            >
              Price Calculator
            </button> */}
                            <Link
                                id="navItem1"
                                to="/pricecalculator"
                                onClick={(e) => {
                                    e.preventDefault();
                                    tryToNavigate("/pricecalculator");
                                }}
                                className={`cursor-pointer py-2 rounded-full w-fit ${path === "/pricecalculator"
                                    ? "text-white cursor-pointer bg-primary-red -ml-5 px-6 text-sm font-medium"
                                    : "text-start font-medium text-gray-600"
                                    }`}
                            >
                                Pricing Calculator
                            </Link>
                            {/* <button
              id="navItem1"
              onClick={() => {
                tryToNavigate("/packages");
              }}
              className={`cursor-pointer py-2 rounded-full  w-fit ${
                path === "/packages"
                  ? "text-white  cursor-pointer bg-primary-red  -ml-5 px-6 "
                  : " text-start font-medium text-gray-600"
              }`}
            >
              Packages
            </button> */}
                            <Link
                                id="navItem1"
                                to="/business"
                                onClick={(e) => {
                                    e.preventDefault();
                                    tryToNavigate("/business");
                                }}
                                className={`cursor-pointer py-2 rounded-full w-fit ${path === "/business"
                                    ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                    : "text-start font-medium text-gray-600"
                                    }`}
                            >
                                Business
                            </Link>
                            <Link
                                id="navItem1"
                                to="/contracts"
                                onClick={(e) => {
                                    e.preventDefault();
                                    tryToNavigate("/contracts");
                                }}
                                className={`cursor-pointer py-2 rounded-full w-fit ${path === "/contracts"
                                    ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                    : "text-start font-medium text-gray-600"
                                    }`}
                            >
                                Contracts
                            </Link>

                            {/* <Link
              id="navItem1"
              to="/packages"
              onClick={(e) => {
                e.preventDefault();
                tryToNavigate("/packages");
              }}
              className={`cursor-pointer py-2 rounded-full w-fit ${path === "/packages"
                  ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                  : "text-start font-medium text-gray-600"
                }`}
            >
              Packages
            </Link> */}
                            {/* <button
              id="navItem1"
              onClick={() => {
                tryToNavigate("/cocktails");
              }}
              className={`cursor-pointer py-2 rounded-full  w-fit ${
                path === "/cocktails"
                  ? "text-white  cursor-pointer bg-primary-red  -ml-5 px-6 "
                  : " text-start font-medium text-gray-600"
              }`}
            >
              Cocktails
            </button> */}
                            <Link
                                id="navItem1"
                                to="/cocktails"
                                onClick={(e) => {
                                    e.preventDefault();
                                    tryToNavigate("/cocktails");
                                }}
                                className={`cursor-pointer py-2 rounded-full w-fit ${path === "/cocktails" || path.startsWith("/cocktails/")
                                    ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                    : "text-start font-medium text-gray-600"
                                    }`}
                            >
                                Cocktails
                            </Link>
                            {user?.roles == "admin" && (
                                <Link
                                    id="navItem1"
                                    to="/alcoholandmixers"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        tryToNavigate("/alcoholandmixers");
                                    }}
                                    className={`cursor-pointer py-2 rounded-full w-fit ${path === "/alcoholandmixers"
                                        ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                        : "text-start font-medium text-gray-600"
                                        }`}
                                >
                                    Alcohol/Mixers
                                </Link>
                            )}
                            <Link
                                id="navItem1"
                                to="/discount"
                                onClick={(e) => {
                                    e.preventDefault();
                                    tryToNavigate("/discount");
                                }}
                                className={`cursor-pointer py-2 rounded-full w-fit ${path === "/discount"
                                    ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                    : "text-start font-medium text-gray-600"
                                    }`}
                            >
                                Discounts
                            </Link>
                            <Link
                                id="navItem1"
                                to="/billing"
                                onClick={(e) => {
                                    e.preventDefault();
                                    tryToNavigate("/billing");
                                }}
                                className={`cursor-pointer py-2 rounded-full w-fit ${path === "/billing"
                                    ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                    : "text-start font-medium text-gray-600"
                                    }`}
                            >
                                Billing
                            </Link>
                            <Link
                                id="navItem1"
                                to="/reward"
                                onClick={(e) => {
                                    e.preventDefault();
                                    tryToNavigate("/reward");
                                }}
                                className={`cursor-pointer py-2 rounded-full w-fit ${path === "/reward"
                                    ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                    : "text-start font-medium text-gray-600"
                                    }`}
                            >
                                Reward Points
                            </Link>
                            <Link
                                id="navItem1"
                                to="/resources"
                                onClick={(e) => {
                                    e.preventDefault();
                                    tryToNavigate("/resources");
                                }}
                                className={`cursor-pointer py-2 rounded-full w-fit ${path === "/resources"
                                    ? "text-white cursor-pointer bg-primary-red -ml-5 px-6"
                                    : "text-start font-medium text-gray-600"
                                    }`}
                            >
                                Resources
                            </Link>
                            {/* <button
              id="navItem1"
              onClick={() => {
                tryToNavigate("/discount");
              }}
              className={`cursor-pointer py-2  rounded-full  w-fit  ${
                path === "/discount"
                  ? "text-white  cursor-pointer bg-primary-red  -ml-5 px-6"
                  : " text-start font-medium text-gray-600"
              }`}
            >
              Discounts
            </button> */}
                        </div>
                    </div>
                    <div className="shrink-0 pt-4">
                        <div className="flex flex-col gap-2">
                            <p
                                onClick={() => setLogoutModal(true)}
                                className="text-start font-medium text-gray-600 cursor-pointer"
                            >
                                Logout
                            </p>
                        </div>
                    </div>
                </div>
                {modal && (
                    <ChangesAlert
                        isOpen={modal}
                        title="Unsaved Changed"
                        desc={path === "/quoteBuilder" ? "Are you sure you want to leave without saving this quote?" : "You have unsaved changes. Are you sure you want to leave?"}
                        positiveButtonText="No, Stay"
                        negativeButtonText="Yes, Leave"
                        handleDiscardChanges={handleModalCancel}
                        handleSaveChanges={handleModalOkay}
                    />
                )}
                {logoutModal && (
                    <LogoutModalComp
                        isOpen={logoutModal}
                        title="Logout"
                        desc="Are you sure you want to logout"
                        positiveButtonText="No, Stay"
                        negativeButtonText="Yes, Leave"
                        handleDiscardChanges={logoutUser}
                        handleSaveChanges={canelLogoutFun}
                    />
                )}
            </div>
        </div>
    );
};
